import React from "react";

/**
 * Variação percentual contra o mesmo período do mês anterior.
 *
 * ⚠ `null` significa "não havia base de comparação" (cliente novo, colaborador que não apontou no
 * período anterior) — e aí mostramos um traço, não "+100%". Δ sobre zero não é crescimento
 * infinito: é ausência de comparação, e exibi-lo como número inventaria uma tendência.
 */
const DeltaChip: React.FC<{ value?: number | null; suffix?: string }> = ({ value, suffix }) => {
  if (value == null) {
    return (
      <span className="text-[11px] font-medium tabular-nums text-gray-400 dark:text-gray-500" title="Sem base de comparação no período anterior">
        —
      </span>
    );
  }

  const up = value >= 0;
  return (
    <span
      className={`text-[11px] font-semibold tabular-nums ${
        up ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"
      }`}
    >
      {up ? "+" : ""}
      {value.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%{suffix ? ` ${suffix}` : ""}
    </span>
  );
};

export default DeltaChip;
